'use strict';
var parent = require('../../actual/array/fill');

module.exports = parent;
